var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//region import

import uuid from 'uuid';
import uniqWith from 'lodash/uniqWith';

// models
import model from '../base.model';
import { loginModel } from '../auth/login.model';
import { errorModel } from '../service/error.model';

// storage
import { getServerUrl as settingsGetServerUrl, saveLastVisitDate as settingsSaveLastVisitDate } from '../../device/settings.storage';
import { save as alertsStorageSave, get as alertsStorageGet, init as alertsStorageInit } from '../../device/alerts.storage';

// utils
import { processItems, compareAlerts, compareUnickAlerts } from '../../services/core/alerts/alerts.helper';
import { dateToTst, tstToMomentDate, dateToMomentDate } from '../../utils/helpers';
import { addToStorage, getFromStorage, mergeStateDateGroupedItems } from '../../services/core/alerts/alerts.algorithms';

// constants
import { DATE_DETAILS_FORMAT, TIME_DETAILS_FORMAT, DATEPICKER_FORMAT } from '../../constants/data.constant';
import { ALERTS_PER_DIRECTION, alertsDataDirection as direction } from '../../services/core/alerts/alerts.constant';
import urls from '../../constants/urls.constant';

//endregion


class alertModel extends model {
    //region init

    static create() {
        return _extends({}, super.create(), {
            items: [],
            dateGroupedItems: [],
            storage: {}
        });
    }

    //endregion
    //region model

    static actionStorageInit(model) {
        return dispatch => {
            const cb = data => {
                const initialState = model.create();
                dispatch({
                    type: model.TYPE__ON_STORAGE_INIT,
                    payload: {
                        model,
                        modelClient: _extends({}, initialState, {
                            storage: data
                        })
                    }
                });
            };

            return alertsStorageInit(cb, model.MODEL_NAME);
        };
    }

    static getReduceMethod(model, type) {
        const reduceMethod = super.getReduceMethod(model, type);
        if (reduceMethod) {
            return reduceMethod;
        }
        const reducers = {
            [model.TYPE__ON_STORAGE_INIT]: model.reduceGet.bind(model),
            [model.TYPE_CLEAR_NEW_ITEMS]: model.reduceClearNewItems.bind(model)
        };

        return reducers[type];
    }

    //endregion
    //region api alerts

    static apiGet(clientApiMethod, params = {}, dispatch) {
        var _this = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this.mapToServer(params);
            const { urlParams } = serverModel;
            const authData = yield loginModel.storageGetAuthToken(loginModel);
            const { authToken } = authData;
            const serverUrl = yield settingsGetServerUrl();
            const _clientApiMethod = clientApiMethod;

            // do reset flag of new alerts before start request for alerts
            // dispatch(this.actionClearNewItems(this));

            return new Promise(function (resolve, reject) {
                alertsStorageGet().then(function (storageData) {
                    // get from storage cached alerts
                    let alertsFromStorage = getFromStorage(storageData, params.date, params.showImportant);

                    // revert to server format
                    alertsFromStorage.prev = alertsFromStorage.prev.map(_this.toReverseClientItem);
                    alertsFromStorage.next = alertsFromStorage.next.map(_this.toReverseClientItem);

                    //region helpers
                    const createPromise = function (storageAlerts, alertsDataDirection) {
                        urlParams.limit = ALERTS_PER_DIRECTION - storageAlerts.length;
                        urlParams.alertsDataDirection = alertsDataDirection;
                        const url = urls.core.getAlerts(urlParams);

                        if (0 < urlParams.limit && urlParams.limit <= ALERTS_PER_DIRECTION) {
                            return _clientApiMethod(serverUrl, url, serverModel.payload, authToken);
                        }

                        return new Promise(function (resolve) {
                            // setTimeout(() => {
                            resolve({
                                fromStorage: true,
                                items: storageAlerts
                            });
                            // }, 2000);
                        });
                    };

                    const processPromiseResponse = function (response, alertsDataDirection) {
                        if (!response) {
                            return [];
                        }

                        if (response.fromStorage) {
                            response = response.items;
                        } else {
                            if (response && response.length) {
                                response.forEach(function (item) {
                                    item.index = uuid.v4();
                                });
                            }

                            if (alertsDataDirection === direction.UP) {
                                response = [...response, ...alertsFromStorage.prev];
                            }

                            if (alertsDataDirection === direction.DOWN) {
                                response = [...alertsFromStorage.next, ...response];
                            }
                        }

                        return response;
                    };
                    //endregion

                    const promises = [];
                    const directions = [];

                    switch (urlParams.alertsDataDirection) {
                        case direction.UP_DOWN:
                            {
                                directions.push(direction.UP);
                                promises.push(createPromise(alertsFromStorage.prev, direction.UP));

                                directions.push(direction.DOWN);
                                promises.push(createPromise(alertsFromStorage.next, direction.DOWN));
                                break;
                            }
                        case direction.UP:
                            {
                                directions.push(direction.UP);
                                promises.push(createPromise(alertsFromStorage.prev, direction.UP));
                                break;
                            }
                        case direction.DOWN:
                            {
                                directions.push(direction.DOWN);
                                promises.push(createPromise(alertsFromStorage.next, direction.DOWN));
                                break;
                            }
                        default:
                            {
                                break;
                            }
                    }

                    // process promises
                    Promise.all(promises).then(function (data) {
                        const prevResponse = processPromiseResponse(data[0], directions[0]);
                        const nextResponse = processPromiseResponse(data[1], directions[1]);
                        let fullResponse = [...prevResponse, ...nextResponse];

                        fullResponse = uniqWith(fullResponse, compareUnickAlerts);
                        resolve(fullResponse);
                    }).catch(reject); // TODO this reject must use try/catch mechanizm from baseModel
                });

                return null;
            });
        })();
    }

    static processServerResponse(dispatch, params, model, serverResponse, history) {
        if (serverResponse === null) {
            return;
        }

        dispatch(errorModel.actionClearNetworkError(errorModel));
        const modelClient = model.mapToClient(serverResponse);
        alertsStorageGet().then(oldStorageData => {
            let storageData = addToStorage(oldStorageData, modelClient.items, params.date, params.showImportant);
            alertsStorageSave(storageData).then(data => {
                modelClient.alertsDataDirection = params.alertsDataDirection;
                modelClient.storage = data;
                dispatch(model.dispatchModel({ modelClient, model }));
            });
        });
    }

    static isClientEmpty(clientModel) {
        return !clientModel || !clientModel.items || !clientModel.items.length;
    }

    static mapToClient(serverModel) {
        if (!serverModel || !serverModel.length) {
            return this.create();
        }

        const items = serverModel.map(this.toClientItem);
        items.sort(compareAlerts);

        return {
            items
        };
    }

    static toClientItem(serverModelItem) {
        const item = {
            dateRaw: serverModelItem.last,
            dateGroup: tstToMomentDate(serverModelItem.last, DATEPICKER_FORMAT),
            date: tstToMomentDate(serverModelItem.last, DATE_DETAILS_FORMAT),
            time: tstToMomentDate(serverModelItem.last, TIME_DETAILS_FORMAT),
            title: serverModelItem.title,
            module: serverModelItem.module,
            severity: serverModelItem.severity,
            status: serverModelItem.status,
            message: serverModelItem.message,
            index: serverModelItem.index
        };

        return item;
    }

    static toReverseClientItem(clientModelItem) {
        const item = {
            last: clientModelItem.dateRaw,
            title: clientModelItem.title,
            module: clientModelItem.module,
            severity: clientModelItem.severity,
            status: clientModelItem.status,
            message: clientModelItem.message,
            index: clientModelItem.index
        };

        return item;
    }

    static mapToServer(params) {
        if (super.isEmpty(params)) {
            return {};
        }

        const {
            alertsDataDirection,
            date,
            showImportant
        } = params;

        return {
            urlParams: {
                alertsDataDirection,
                // module: 'ApplianceService',
                date: dateToTst(dateToMomentDate(date)),
                severity: showImportant ? 'WARNING' : '' //'INFO'
            }
        };
    }

    static reduceGet(stateModel, action) {
        // const { items: _items, } = stateModel;
        const { modelClient, model } = action.payload;
        const {
            items,
            alertsDataDirection,
            storage
        } = modelClient;

        let result = null;

        // 1 merge state if exists
        if (stateModel.dateGroupedItems.length) {
            result = {
                dateGroupedItems: mergeStateDateGroupedItems(stateModel.dateGroupedItems, items)
            };
        } else {
            result = processItems(items);
        }

        // 3 post processing
        settingsSaveLastVisitDate();

        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                isLoading: false,
                alertsDataDirection,
                hasNewItems: !!(items && items.length),
                newItems: items,
                storage,
                // dateGroupedItems: JSON.parse(JSON.stringify(result.dateGroupedItems)),
                dateGroupedItems: [...result.dateGroupedItems]
            })
        };
    }

    //endregion
    //region clear new items (background task)

    static actionClearNewItems(model) {
        return dispatch => {
            dispatch({
                type: model.TYPE_CLEAR_NEW_ITEMS,
                payload: {
                    model
                }
            });
        };
    }

    static reduceClearNewItems(stateModel, action) {
        const { model } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                hasNewItems: false,
                newItems: []
            })
        };
    }

    //endregion
}

alertModel.MODEL_NAME = 'alertModel';
alertModel.TYPE_REQUEST = 'REQUEST_ALERTS';
alertModel.TYPE_FROM_SERVER = 'GET_ALERTS';
alertModel.TYPE_CLEAR = 'CLEAR_ALERTS';
alertModel.TYPE_CLEAR_NEW_ITEMS = 'TYPE_CLEAR_NEW_ITEMS';
alertModel.TYPE__ON_STORAGE_INIT = 'TYPE_ALERTS__STORAGE_INIT';
export { alertModel };


// WEBPACK FOOTER //
// ./~/pluton-core/lib/models/core/alert.model.js